import { API_LIMIT_DATA } from '../utils/constants';
import { Axios } from './Axios';

export async function fetchDiscoverList(limit = API_LIMIT_DATA, offset = 1) {
  const url = `discover?limit=${limit}&page=${offset}`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function fetchDiscoverSideMenu() {
  const url = 'discover/menu';
  return Axios({
    url,
    method: 'get'
  });
}
